import { render } from "./JobManagement.vue?vue&type=template&id=74859654&scoped=true"
import script from "./JobManagement.vue?vue&type=script&lang=js"
export * from "./JobManagement.vue?vue&type=script&lang=js"

import "./JobManagement.vue?vue&type=style&index=0&id=74859654&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74859654"]])

export default __exports__